import React from "react";
import NavItem from "./NavItem";
import { sections } from "../lib/data";
import type { SectionKey } from "../lib/types";

interface SidebarProps {
  activeSection: SectionKey;
  onNavigate: (section: SectionKey) => void;
  open: boolean;
}

function Sidebar({ activeSection, onNavigate, open }: SidebarProps) {
  const sectionEntries = Object.entries(sections);

  return (
    <aside
      className={[
        "w-56 flex-shrink-0 h-screen sticky top-0 flex flex-col border-r border-border bg-bg-surface",
        "px-3 py-6 gap-1 z-[90] transition-transform duration-200 ease-out",
        "max-md:fixed max-md:top-0 max-md:left-0 max-md:bottom-0",
        open ? "max-md:translate-x-0" : "max-md:-translate-x-full",
      ].join(" ")}
    >
      {/* Logo */}
      <div className="px-3.5 pb-5 flex items-center gap-2.5">
        <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-accent to-brand flex items-center justify-center text-sm font-bold font-mono text-bg">
          EM
        </div>
        <div>
          <div className="text-sm font-semibold text-content leading-tight">
            Eric Mwangi
          </div>
          <div className="text-2xs text-content-muted font-mono">developer</div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex flex-col gap-0.5">
        {sectionEntries.map(([key, { label, icon }]) => (
          <NavItem
            key={key}
            label={label}
            section={key as SectionKey}
            icon={icon}
            active={activeSection === key}
            onClick={onNavigate}
          />
        ))}
      </nav>

      {/* Footer */}
      <div className="mt-auto px-3.5 text-2xs text-content-muted font-mono leading-relaxed">
        <div>Kenya 🇰🇪</div>
        <div className="mt-1 opacity-60">© 2025</div>
      </div>
    </aside>
  );
}

export default Sidebar;